import * as React from "react";
import "../App.css";
import excelDoc from '../images/ExcelGuide.png'
import { useNavigate } from "react-router-dom";

// Mui
import { Button, Card, CardActions, CardContent, CardMedia, Grid, Input, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useDispatch } from "react-redux";
import { newPark } from "../features/WTG/TurbineSlice";
import { UpdateCoordinates } from "../API";


export default function HowToExcelView() {

 

    const dispatch = useDispatch();
    let navigate = useNavigate();

    const fileState = {

        // Initially, no file is selected
        selectedFile: null,
        selectedFileName: null,
        input: false
    };
    const [file, setFile] = React.useState(fileState.selectedFile);
    const [fileName, setFileName] = React.useState(fileState.selectedFileName);


    // On file select (from the pop up)
    const onFileChange = event => {

        setFile(event.target.files[0]);
        setFileName(event.target.files[0].name)
    };
    const clickSubmit = async (e) => {

        e.preventDefault();
        const formData = new FormData();
        formData.append(
            "file", file
        );
        try {
            const res = await UpdateCoordinates(formData);
        } catch (error) {
            console.log(error)
        }
        dispatch(newPark(true))
        navigate("/parkview", { replace: true });
    };

    return (
        <Box
            className="wrapper"
            >
            <Grid
                marginTop="10%"
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
            >

                <Card sx={{ width:"490px",backgroundColor:"#256aa749" }}>
                    
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            Upload Excel document
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            Upload an Excel/xlsx file, to configurate a windturbine park.
                        </Typography>
                    </CardContent>
                    <CardActions>
                       
                        <Input onChange={onFileChange} type="file"
                        inputProps={{ accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}}
                        
                        >
                        </Input>
                      {file !== null?
                        <Button
                         variant="contained" size="small" onClick={clickSubmit} color="success" style={{margin:"0px", color:"white" }}>
                            
                            Upload {fileName}
                            
                        </Button>
                        :null}  
                    </CardActions>
                </Card>

            </Grid>
        </Box>
    );
};